export type Language = 'zh' | 'en';

export const translations = {
  zh: {
    nav: {
      about: '关于我们',
    },
    hero: {
      slides: [
        {
          title: '嗨，我叫歪觅',
          subtitle: 'AI双轮足陪伴机器人',
        },
        {
          title: '我能陪你聊天',
          subtitle: '丝滑的语音交互系统',
        },
      ],
    },
    about: {
      title: '关于我们',
      brand: '歪觅机器人',
      description1:
        '歪觅是{company}的机器人品牌，致力于研发全新一代的家庭陪伴机器人。我们的旗舰产品，<bold>Wyndme O1 Pro</bold>，集出色的运动能力与AI大脑于一身。',
      description2:
        '歪觅采用了独特的外形与运动结构设计，使其具备在家庭场景中自由活动的潜力。我们不是在制造AI玩具，而是想要创造出真正的家庭成员。',
      features: {
        ai: {
          title: 'AI核心',
          desc: '大模型加持的对话系统',
        },
        motion: {
          title: '运动能力',
          desc: '双轮足自平衡结构',
        },
        companion: {
          title: '陪伴',
          desc: '全方位陪伴',
        },
      },
      location: '广州，中国',
    },
    footer: {
      contact: '联系方式：wyndme@qq.com',
      rights: '版权所有',
      icp: '粤ICP备2025488951号-2',
    },
  },
  en: {
    nav: {
      about: 'About Us',
    },
    hero: {
      slides: [
        {
          title: 'Hi, I\'m Wyndme',
          subtitle: 'AI Two-Wheeled Companion Robot',
        },
        {
          title: 'I Can Chat With You',
          subtitle: 'Smooth Voice Interaction System',
        },
      ],
    },
    about: {
      title: 'About Us',
      brand: 'Wyndme Robot',
      description1:
        'Wyndme is a robot brand of Kuiniu Intelligent Technology (Guangzhou) Co., Ltd, dedicated to developing a new generation of family companion robots. Our flagship product, <bold>Wyndme O1 Pro</bold>, combines excellent mobility with an AI brain.',
      description2:
        'Wyndme features a unique appearance and motion structure design, enabling it to move freely in home environments. We are not making AI toys, but creating true family members.',
      features: {
        ai: {
          title: 'AI Core',
          desc: 'Large Model Powered Dialogue System',
        },
        motion: {
          title: 'Mobility',
          desc: 'Two-Wheeled Self-Balancing Structure',
        },
        companion: {
          title: 'Companionship',
          desc: 'All-Around Companions',
        },
      },
      location: 'Guangzhou, China',
    },
    footer: {
      contact: 'Contact: wyndme@qq.com',
      rights: 'All Rights Reserved',
      icp: '粤ICP备2025488951号-2',
    },
  },
};
